export default __webpack_public_path__ + "static/1-mobile-882ae763cd4fbe1050aa28ede21c8c05.svg";